import {
    Exercise,
    GhostButton,
    LabelBody,
    LabelDisplay1,
    LabelDisplay2,
    SecondaryButton,
    Spacer,
    SwirlyBox,
} from '../../components';
import { ExerciseStatus } from '../../interfaces';
import { VideoExerciseView } from '../../views';
import { ExerciseViewProps } from '../exercises';

export function Module1S2ExerciseIntro(props: ExerciseViewProps) {
    return (
        <Exercise title="Viden om…">
            <Page />
        </Exercise>
    );
    function Page() {
        switch (props.exercise.CurrentPage) {
            case 2:
                return <Page2 {...props} />;
            case 1:
            default:
                return <Page1 {...props} />;
        }
    }
}

function Page1({ exercise, onContinue }: ExerciseViewProps) {
    return (
        <>
            <LabelDisplay2 className="mb-10">
                Hvad betyder det at se tanker som bare tanker?
            </LabelDisplay2>
            <LabelBody>
                Hvorfor er der så mange af dem og kan vi ikke bare få dem til at
                gå væk? Videoen præsenterer dig for, hvordan du kan se tanker i
                et andet lys og hvilke muligheder det giver dig. Når du er klar,
                kan du trykke på afspil.
            </LabelBody>

            <VideoExerciseView className="mt-20" exercise={exercise} />

            <Spacer class="mt-20" />

            <SecondaryButton
                className="self-center"
                onClick={() =>
                    onContinue({
                        status: ExerciseStatus.InProgress,
                        pageNumber: 2,
                    })
                }
            >
                Videre
            </SecondaryButton>
        </>
    );
}

function Page2({ onContinue }: ExerciseViewProps) {
    return (
        <>
            <LabelDisplay1 className="mb-10">
                Lad tanker være tanker
            </LabelDisplay1>
            <LabelBody>
                I denne del af modulet vil du eksperimentere med øvelser, der
                hjælper dig med at bemærke dine tanker, uden at blive fanget af
                dem. Du får mulighed for at øve dig i at få tankerne lidt på
                afstand.
            </LabelBody>
            <SwirlyBox className="my-30">
                Er du klar til at gå i gang?
            </SwirlyBox>
            <Spacer />
            <SecondaryButton
                className="self-center"
                onClick={() =>
                    onContinue({
                        status: ExerciseStatus.Completed,
                        goToNext: true,
                    })
                }
            >
                Lad os komme i gang
            </SecondaryButton>
            <GhostButton
                className="mt-20 self-center"
                onClick={() =>
                    onContinue({
                        status: ExerciseStatus.Completed,
                        goToNext: false,
                    })
                }
            >
                Vender tilbage senere
            </GhostButton>
        </>
    );
}
